<template>
  <c-layout :spinning="page.loading">
    <a-row class="table-title">
      <a-col :span="2" style="text-align: right">
        年度：
      </a-col>
      <a-col :span="4">
        <a-select v-model="tables.search.year" style="width: 100%" placeholder="公示年度" allowClear>
          <a-select-option v-for="item in options.years" :value="item.value">{{ item.label }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4" :offset="1">
        <a-button icon="search" type="primary" @click="startSearch">搜索</a-button>
      </a-col>
    </a-row>
    <a-divider/>
    <a-tabs type="card" @change="changeTab" v-model="tables.search.dataType">
      <a-tab-pane :key="item.key" v-for="item in options.tabs">
        <span slot="tab">
           <a-badge :dot="item.count>0">{{ item.name }}</a-badge>
        </span>
        <a-table :data-source="tables.dataSource.publish" :columns="tables.columns"
                 :pagination="true" rowKey="id">
          <template slot="action" slot-scope="text, record">
            <a-button text="拒绝" type="danger" @click="showUnaccept(record)" size="small">拒绝</a-button>
            <a-divider type="vertical"/>
            <c-pop-button title="确定要通过吗" text="通过" type="primary" @click="accept(record)"/>
            <a-divider type="vertical"/>
            <c-pop-button title="确定要删除吗" text="删除" type="danger" @click="removePublish(record)"/>
            <a-divider type="vertical"/>
            <a-button size="small" @click="showEditTime(record)">修改时间</a-button>
          </template>
          <template slot="name" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <template slot="region" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="text.area" v-if="text">
              {{ text.simpleName }}
            </a-tooltip>
            <span v-else>-</span>
          </template>
          <template slot="status" slot-scope="text, record">
            <span style="display: none">{{ text }}</span>
            <a-tag color="green" v-if="text===0">待初审</a-tag>
            <a-tag color="blue" v-if="text===1 && record.status===0">待二审</a-tag>
            <a-tag color="green" v-if="text===1 && record.status===1">二审通过</a-tag>
            <a-tag color="red" v-if="text===1  && record.status===2">二审驳回</a-tag>
            <a-tag color="red" v-if="text===2 ">初审驳回</a-tag>
          </template>
          <template slot="wordFile" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.wordFile.uploadName">
              <p @click="viewPDF(record)"> {{ record.wordFile.uploadName }}</p>
            </a-tooltip>
          </template>
          <template slot="excelFile" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.excelFile.uploadName">
              {{ record.excelFile.uploadName }}
            </a-tooltip>
          </template>
          <template slot="excelFileList" slot-scope="text, record">
            <a-popover>
              <template slot="content" v-for="item in record.excelFileList">
                <p @click="viewFile(item)">{{ item.customName }}</p>
              </template>
              <a-button size="small">显示列表</a-button>
            </a-popover>
          </template>
          <template slot="publishFileList" slot-scope="text, record">
            <a-popover>
              <template slot="content" v-for="item in record.publishFileList">
                <p>{{ item.uploadName }}</p>
              </template>
              <a-button size="small">显示列表</a-button>
            </a-popover>
          </template>
          <template slot="unacceptContent" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="text" v-if="text">
              {{ text }}
            </a-tooltip>
            <span v-else>-</span>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal :visible="show.viewExcel" width="75%" @cancel="closeExcelView" :closable="false">
      <div class="excel-parent">
        <div id="excelView" :style="excelView.spreadStyle"></div>
      </div>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeExcelView">关闭</a-button>
      </div>
    </a-modal>
    <a-modal :visible="show.editTime" width="30%" @cancel="closeEditTime" :closable="false">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="修改时间" prop="name">
          <a-date-picker :locale="locale" v-model="publishTime"/>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeEditTime">关闭</a-button>
        <a-button type="primary" @click="saveEditTime">保存</a-button>
      </div>
    </a-modal>
    <a-modal :visible="show.unacceptContent" width="30%" @cancel="closeEditTime" :closable="false">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="拒绝理由" prop="name">
          <a-textarea placeholder="输入拒绝理由" :rows="8" allow-clear v-model="tables.unacceptContent"/>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeUnaccept">关闭</a-button>
        <c-pop-button size="default" title="确定要拒绝吗" text="拒绝" type="danger" @click="unaccept"/>
      </div>
    </a-modal>
  </c-layout>
</template>

<script>
import CPopButton from "@comp/c-pop-button";
import {CustomApis as api} from "@/api/CustomApis";
import CTableSearch from "@/components/c-table-search"
import {SysApis} from "@/api/SysApis";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import commonApi from "@/api/CommonApi";
import {getYears,defaultYear} from "@/utils/years.js";

const pdfjsLib = require("pdfjs-dist/legacy/build/pdf.js");
export default {
  name: "publish-list",
  components: {
    CTableSearch,
    CPopButton,
  },
  watch: {},
  data() {
    return {
      locale,
      excelView: {
        spreadStyle: {
          width: '100%',
          height: '100%'
        },
        spread: null,
        excelIo: null,
        init: false,
      },
      page: {
        loading: false
      },
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      tables: {
        columns: [],
        dataSource: {
          publish: [],
        },
        search: {
          year: '',
          dataType: '0',
          regionId: ''
        },
        unacceptContent: "",
      },
      show: {
        fileListButton: false,
        fileList: false,
        viewExcel: false,
        editTime: false,
        unacceptContent: false,
      },
      options: {
        columns: {
          publish: [
            {
              dataIndex: 'region',
              title: '单位',
              width: '15%',
              scopedSlots: {
                customRender: 'region'
              }
            },
            {
              dataIndex: 'wordFile',
              title: '公示说明',
              width: '15%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'wordFile'
              }
            },
            {
              dataIndex: 'excelFile',
              title: '预算公示文件',
              width: '15%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'excelFile'
              }
            },
            {
              dataIndex: 'excelFileList',
              title: '公示文件列表',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'excelFileList'
              }
            },
            {
              dataIndex: 'twiceCheck',
              title: '状态',
              width: '10%',
              scopedSlots: {
                customRender: 'status'
              }
            },
            {
              dataIndex: 'year',
              title: '年度',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'year'
              }
            },
            {
              dataIndex: 'publishTime',
              title: '发布时间',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'publishTime'
              }
            },
            {
              dataIndex: 'unacceptContent',
              title: '拒绝理由',
              width: '15%',
              scopedSlots: {
                customRender: 'unacceptContent'
              }
            },
            {
              dataIndex: 'action',
              title: '操作',
              scopedSlots: {customRender: 'action'},
              width: '35%'
            },
          ],
          publishZsq: [
            {
              dataIndex: 'publishFileList',
              title: '公示文件列表',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'publishFileList'
              }
            },
            {
              dataIndex: 'status',
              title: '状态',
              width: '10%',
              scopedSlots: {
                customRender: 'status'
              }
            },
            {
              dataIndex: 'year',
              title: '年度',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'year'
              }
            },
            {
              dataIndex: 'publishTime',
              title: '发布时间',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'publishTime'
              }
            },
            {
              dataIndex: 'unacceptContent',
              title: '拒绝理由',
              width: '15%',
              scopedSlots: {
                customRender: 'unacceptContent'
              }
            },
            {
              dataIndex: 'action',
              title: '操作',
              scopedSlots: {customRender: 'action'},
              width: '35%'
            },
          ],
        },
        tabs: [
          {key: '0', name: '预算公示', permissions: '', count: 0},
          {key: '1', name: '决算公示', permissions: '', count: 0},
          //{key: '2', name: '预算绩效目标', permissions: '', count: 0},
          //{key: '3', name: '决算绩效评价', permissions: '', count: 0},
        ],
        types: [
          {value: 0, label: '预算'},
          {value: 1, label: '决算'},
          //{value: 2, label: '预算绩效目标'},
          //{value: 3, label: '决算绩效评价'},
        ],
        years: getYears(),
        fileList: [],
      },
      publishTime: null,
      rowId: '',
      sse: null,
      socket: null,
      userInfo: {}
    };
  },
  activated() {
    this.getUserInfo().then(e => {
      if (e.status) {
        this.userInfo = e.data
        this.tables.columns = this.options.columns.publish
        if (this.tables.search.dataType >= 4) {
          this.tables.columns = this.options.columns.publishZsq
        }
        this.getList()
      }
    })
    this.getCount()
  },
  methods: {
    getCount() {
      const _this = this
      _this.options.tabs.forEach(e => {
        _this.$http.get(`${api.getPublishCountByTypeJYJ}/${e.key}`).then(result => {
          if (result.status !== 200) {
            this.$message.error(result.message);
            return;
          }
          if (result.data !== null) {
          }
          e.count = result.data
        }).catch(function (error) {
          console.error('出现错误:', error);
        });
      })
    },
    getUserInfo() {
      return commonApi.getUserInfo().then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {

          return Promise.resolve({status: true, data: result.data})
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      })
    },
    saveEditTime() {
      let publishTime = this.publishTime.format('yyyy-MM-DD')
      let data = {
        publishTime: publishTime
      }
      this.$http.post(`${api.changeTime}/${this.rowId}`, data).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
        }
        this.refreshData()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
      this.closeEditTime()
    },
    showEditTime(e) {
      this.publishTime = new moment(e.publishTime)
      this.rowId = e.id
      this.show.editTime = true
    },
    closeEditTime() {
      this.show.editTime = false
      this.publishTime = null
    },
    closeExcelView() {
      this.show.viewExcel = false
    },
    async viewPDF(e) {
      window.open(`/pdfjs/web/viewer.html?file=${encodeURIComponent(e.wordFile.path)}`);
    },
    viewFile(e) {
      const _this = this
      _this.show.viewExcel = true
      this.$nextTick(() => {
        _this.page.loading = true;
        let excelView = document.querySelector('#excelView')
        // 在mounted中声明 spread 和excelIo ，避免了改变某个参数后再次请求数据渲染界面的问题，若在 openExcel方法中声明会在该excel下方再生成一个excel
        if (!_this.excelView.init) {
          _this.excelView.spread = new GC.Spread.Sheets.Workbook(excelView);
          _this.excelView.excelIo = new GC.Spread.Excel.IO();
          _this.excelView.init = true
        }
        _this.openExcel(e.path)
        _this.page.loading = false;
      })
    },
    openExcel(path) {
      const _this = this
      this.$http.get(path, {responseType: 'blob'}).then(response => {
        let blob = new Blob([response])
        _this.excelView.excelIo.open(blob, function (json) {
          _this.excelView.spread.fromJSON(json);
          _this.excelView.spread.options.tabNavigationVisible = false;
          _this.excelView.spread.options.tabEditable = true;
          _this.excelView.spread.options.allowSheetReorder = false;
          _this.excelView.spread.options.newTabVisible = false;
        }, function (e) {
          _this.$message.error(e.errorMessage);
        }, {});
      })
    },
    startSearch() {
      this.tables.dataSource.publish = []
      this.tables.search.regionId = this.userInfo.regionId
      this.$http.post(`${api.searchAuditPublishYJY}`, this.tables.search).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          this.tables.dataSource.publish = result.data
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    loadPage() {
      this.page.loading = true
    },
    endLoadPage() {
      this.page.loading = false
    },
    accept(e) {
      console.log(e)
      this.$http.get(`${api.accept}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
        }
        this.refreshData()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    showUnaccept(e) {
      this.rowId = e.id
      this.tables.unacceptContent = ''
      this.show.unacceptContent = true
    },
    closeUnaccept() {
      this.rowId = ''
      this.show.unacceptContent = false
    },
    unaccept() {
      let data = {
        id: this.rowId,
        unacceptContent: this.tables.unacceptContent,
      }
      this.$http.post(`${api.unaccept}`, data).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
        }
        this.closeUnaccept()
        this.refreshData()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    removePublish(e) {
      this.$http.post(`${api.delPublish}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.refreshData()
        this.$message.success(result.message)
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    getList() {
      this.tables.search.regionId = this.userInfo.regionId
      this.tables.dataSource.publish = []
      this.$http.post(`${api.searchAuditPublishYJY}`, this.tables.search).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          this.tables.dataSource.publish = result.data
        }
        this.endLoadPage()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    renameFile(file, index) {
      this.$http.post(SysApis.renameFile, file).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.$set(this.options.fileList, index, result.data)
        this.$message.success(result.message);
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    submitSearch() {
      this.$http.post(`${SysApis.searchUser}`, this.searchText).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        if (result.data !== null) {
          this.dataSource = result.data.sort((a, b) => {
            return b.id - a.id
          });
        }
        this.endLoadPage()
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    changeTab(e) {
    	this.tables.columns = this.options.columns.publish
        if (this.tables.search.dataType >= 4) {
          this.tables.columns = this.options.columns.publishZsq
        }
      this.tables.search.dataType = e
      this.tables.columns[2].title = `${this.options.types[e].label}公示文件`
      this.getList()
    },
    refreshData() {
    	this.tables.columns = this.options.columns.publish
        if (this.tables.search.dataType >= 4) {
          this.tables.columns = this.options.columns.publishZsq
        }
      this.options.fileList = []
      this.getList()
    },
  }
}
</script>

<style lang="less" scoped>
.excel-parent {
  width: 100%;
  height: 500px;
}

.table-title {
  padding: 10px;
}

.drawer-bottom-button {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.file-list {
  height: 30vh;
  overflow: auto;
}

/*滚动条整体样式*/
.file-list::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-right: 10px;
  opacity: 0.2;
}

/*滚动条里面小方块(滑块 )*/
.file-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}

/*滚动条里面轨道(背景)*/
.file-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  border-radius: 10px;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}
</style>
